export const brand = {
  primary: "#F15A29",
  primaryHover: "#D14F23",
  primaryDisabled: "#C0481F",
  ink: "#1F2024",
  surface: "#FFFFFF",
  platinum: "#F4F4F5",
  textOnPrimary: "#FFFFFF",
} as const;

export type Brand = typeof brand;
